export default (theme) => ({
    errorsMessage: {
        ...theme.typography.body,
        color: theme.colors.semantic.negative500,
        padding: '4px 0',
    },
    errorsTable: {
        border: `1px solid ${theme.colors.semantic.negative500}`,
    },
});
